import React from "react";
import { ContractedWorkshop } from "../../interfaces/altair";
import { useOverlayPopupOpen } from "../../hooks/use-overlay-popup-open";
import "../shared/popup-card.scss";

interface ContractedWorkshopsListProps {
  visible: boolean;
  workshops: ContractedWorkshop[];
  onSelect: (workshop: ContractedWorkshop) => void;
}

export const ContractedWorkshopsList: React.FC<ContractedWorkshopsListProps> = ({
  visible,
  workshops,
  onSelect,
}) => {
  useOverlayPopupOpen(visible);
  if (!visible) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-card popup-card--wide">
        <h3 className="popup-title">اختر مركز الخدمة</h3>
        <div className="popup-scroll-list">
          {workshops.map((workshop) => (
            <button
              key={workshop.workshopId}
              onClick={() => onSelect(workshop)}
              className={`popup-workshop-card${workshop.isNearest ? " popup-workshop-card--nearest" : ""}`}
            >
              {workshop.isNearest && (
                <div className="popup-workshop-badge">الأقرب</div>
              )}
              <div className="popup-workshop-header">
                <div className="popup-workshop-name">{workshop.workshopName}</div>
                {workshop.distance != null && (
                  <div className="popup-workshop-distance">
                    {workshop.distance < 1000
                      ? `${Math.round(workshop.distance)} م`
                      : `${(workshop.distance / 1000).toFixed(1)} كم`}
                  </div>
                )}
              </div>
              <div className="popup-workshop-address">{workshop.address}</div>
              <div className="popup-workshop-meta">
                {workshop.city}
                {workshop.phoneNumber && ` - ${workshop.phoneNumber}`}
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
